'use strict';

if (process.env.TAPLYTICS_KEY) {
  !function () {
    var t = window.Taplytics = window.Taplytics || [];
    if (window._tlq = window._tlq || [], !t.identify && !t.loaded) {
      t.loaded = !0, t.funcs = ['init', 'identify', 'track', 'page', 'reset', 'propertiesLoaded', 'runningExperiments', 'variable', 'codeBlock'], t.mock = function (n) {
        return function () {
          var e = Array.prototype.slice.call(arguments);
          return e.unshift(n), window._tlq.push(e), t;
        };
      };
      for (var n = 0; n < t.funcs.length; n++) {
        var e = t.funcs[n];
        t[e] = t.mock(e);
      }
      t.load = function () {
        var t = document.createElement('script');
        t.type = 'text/javascript', t.async = !0, t.src = '//cdn.taplytics.com/taplytics.min.js';
        var n = document.getElementsByTagName('script')[0];
        n.parentNode.insertBefore(t, n);
      }, t.load();
    }
  }();

  Taplytics.init(process.env.TAPLYTICS_KEY, {
    auto_page_view: false
  });
}


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/modules/taplytics/init.js